import { CommonModule } from '@angular/common';
import {
    Component,
    computed,
    EventEmitter,
    inject,
    input,
    Output,
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    ReactiveFormsModule,
    ValidatorFn,
} from '@angular/forms';
import { CustomDropdownComponent } from '@shared/custom-dropdown/custom-dropdown.component';
import { CustomInputComponent } from '@shared/custom-input/custom-input.component';
import { Ng2TelInputDirective } from '@shared/ng2-tel-input/directives/ng2-tel-input.directive';
import { SaveButtonComponent } from '@shared/save-button/save-button.component';

export interface DynamicFormSchemaField {
    label: string;
    type: string;
    name: string;
    validators: ValidatorFn[];
    options?: {
        label: string;
        value: number | string;
    }[];
    testId?: string;
    placeholder?: string;
}

@Component({
    selector: 'app-form-dynamic-with-config',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CustomInputComponent,
        CustomDropdownComponent,
        SaveButtonComponent,
        Ng2TelInputDirective,
    ],
    templateUrl: './form-dynamic-with-config.component.html',
    styles: ``,
})
export class FormDynamicWithConfigComponent {
    private formBuilder = inject(FormBuilder);
    @Output() onSubmit = new EventEmitter();
    formSchema = input.required<DynamicFormSchemaField[]>();
    form = computed(() =>
        this.formBuilder.group(
            this.formSchema().reduce((acc, curr) => {
                return {
                    ...acc,
                    [curr.name]: new FormControl('', [...curr.validators]),
                };
            }, {})
        )
    );

    submitForm(): void {
        this.form().markAllAsTouched();
        if (this.form().valid) {
            this.onSubmit.emit(this.form().value);
            console.log('Form Submitted', this.form().value);
            // Handle form submission logic here
        } else {
            console.log('Form is invalid');
        }
    }
}
